import { Fragment, useContext, useEffect } from 'react';
import { Redirect, useHistory, useLocation } from 'react-router-dom';
import { AppContext } from '../../contexts/appContext';
import useInternalUrl from '../../hooks/useInternalUrl';

const RedirectToParamUrl = () => {
  const { appMenuItems } = useContext(AppContext);
  const location = useLocation();
  const history = useHistory();
  const params = new URLSearchParams(location.search);
  const redirectParam = params.get('redirect');
  const handleInternalUrl = useInternalUrl();

  // Attempt to get the path of the first menu item. These are dynamic, come from VL,
  // and are unknown to the client.
  const homeScreenRoute = appMenuItems ? appMenuItems[0].path : '/';

  // Check if this is an internal URL
  const isInternalUrl =
    redirectParam &&
    (redirectParam.startsWith('kry://') ||
      redirectParam.startsWith('livi://') ||
      redirectParam.startsWith('vitalitygp://'));

  // If redirect param is an internal URL, handle it directly
  useEffect(() => {
    if (isInternalUrl && redirectParam) {
      // Remove the redirect param from URL to prevent reprocessing
      const newParams = new URLSearchParams(location.search);
      newParams.delete('redirect');
      const newSearch = newParams.toString();
      const newPath = homeScreenRoute + (newSearch ? `?${newSearch}` : '');

      // Replace the current history entry to remove the redirect param
      // This prevents the redirect from being processed again when navigating back
      history.replace(newPath);

      // Process the redirect
      handleInternalUrl(redirectParam);
    }
  }, [
    isInternalUrl,
    handleInternalUrl,
    redirectParam,
    history,
    location.search,
    homeScreenRoute,
  ]);

  // For internal URLs, return empty fragment while navigation happens
  if (isInternalUrl) {
    return <Fragment />;
  }

  // Existing redirect logic for web paths
  return <Redirect to={redirectParam || homeScreenRoute} />;
};

export default RedirectToParamUrl;
